module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ddb5a5a7284f669a2c30d41b4ddf063d.png";